export enum POPINS {
  ConnectPopin = 'ConnectPopin',
  LostPwdPopin = 'LostPwdPopin',
  ConfirmationPopin = 'ConfirmationPopin',
  DoubleFaPopin = 'DoubleFaPopin',
  CommunitiesPropositionsPopin = 'CommunitiesPropositionsPopin',
  UserPrayPopin = 'UserPrayPopin',
  InvitePopin = 'InvitePopin',
  InviteEmailPopin = 'InviteEmailPopin',
  WidgetPopin = 'WidgetPopin',
  PresubscriberDeletedPopin = 'PresubscriberDeletedPopin',
  BroadcastIntentionWidgetPopin = 'BroadcastIntentionWidgetPopin',
  CommunityMembersListPopin = 'CommunityMembersListPopin',
  FacebookConfirmPopin = 'FacebookConfirmPopin',
}
